<!-- eslint-disable prettier/prettier -->
<template>
  <section>
    <transition name="fade">
      <section style="position: absolute; width: 100%;">
        <v-container v-if="preloader">
          <div class="text-center">
            <v-progress-circular indeterminate></v-progress-circular>
          </div>
        </v-container>
      </section>
    </transition>

    <transition name="fade">
      <v-container v-if="!preloader && flag" class="absolute-container">
        <v-row class="absoluteEditCard">
          <div class="col-12 col-md-5">
            <user-card class="content-card" :class="{ inactive: isAdmin }">
              <template v-slot:header>

                <v-btn v-if="isAdmin" class="edit-card-button block-absolute-right"
                  title="Редактировать карточку"
                  variant="text"
                  text
                  @click="openCardEditor()"
                >
                  <v-icon>mdi-pencil-outline</v-icon>
                </v-btn>

                <v-btn style="margin-top: 42px" 
                  v-if="isAdmin && curUser && data.id != currentUserCard"
                  class="edit-card-button block-absolute-right"
                  title="Назначить интервью"
                  variant="text"
                  text
                  @click="addInterview()"
                >
                  <v-icon>mdi-account-multiple-plus</v-icon>
                </v-btn>
              
                <v-chip class="ma-2 block-absolute-left" :class="getStatusColor(data.status)" text-color="white">
                  {{ getUserStatus() }}
                </v-chip>

                <card class="card-user">
                  <div slot="image">
                    <img src="@/assets/img/background.jpg" alt="..." />
                  </div>
                  <div class="author">
                    <div class="img-container border-white"> 
                      <div 
                        v-if="data.avatar"
                        class="custom-bg-img"
                        :style="getStyleAvatar(data.avatar)"
                      ></div>
                      <img v-else
                        src="@/assets/img/no-foto.png"
                      />
                    </div>
                    <h4 class="title custom-title">
                      {{ data.name }} {{ data.lastName }} {{ data.secondName }}
                    </h4>
                    <hr>
                    <div class="card-info">
                      <h5>
                        E-mail
                        <br />
                        <small v-if="data.email">{{ data.email }}</small>
                        <small v-else>нет</small>
                      </h5>
                      <h5>
                        Telegram
                        <br />
                        <small v-if="data.telegram">
                          <a :href="'https://t.me/' + data.telegram" target="_blank" class="pink-text">@{{ data.telegram }}</a>
                        </small>
                        <small v-else>нет</small>
                      </h5>
                      <h5>
                        Телефон
                        <br />
                        <small v-if="data.phone">{{ data.phone }}</small>
                        <small v-else>нет</small>
                      </h5>
                      <h5>
                        Мобильный
                        <br />
                        <small v-if="data.mobile">{{ data.mobile }}</small>
                        <small v-else>нет</small>
                      </h5>
                      <h5>
                        Логин
                        <br />
                        <small v-if="data.login">{{ data.login }}</small>
                        <small v-else>нет</small>
                      </h5>
                      <h5>
                        Система / ID
                        <br />
                        <small v-if="data.externalSystem">{{ data.externalSystem }} / {{ data.externalId }}</small>
                        <small v-else>нет</small>
                      </h5>
                      <!-- <h5>
                        Департамент
                        <br />
                        <small>Разработка</small>
                      </h5> -->
                      <h5>
                        Роль
                        <br />
                        <small v-if="rolesName.length > 0">{{ rolesName[0] }}</small>
                        <small v-else>нет</small>
                      </h5>
                    </div>
                  </div>
                </card>
                <v-row v-if="( !isAdmin && (data.heads.length > 0 || data.subordinates.length > 0 || data.files)) || (isAdmin || data.heads.length > 0 || data.subordinates.length > 0 || data.files)">
                  <v-col md="12">
                    <v-expansion-panels multiple class="custom-list">

                      <v-expansion-panel v-if="data.heads.length > 0">
                        <v-expansion-panel-header>Руководители</v-expansion-panel-header>
                        <v-expansion-panel-content>
                          <user-card class="user-card">
                            <template v-slot:body>
                              <v-list>
                                <v-list-item v-for="item in data.heads" :key="item.id">
                                  
                                  <v-list-item-avatar>
                                    <div 
                                      v-if="item.avatar"
                                      class="custom-bg-img"
                                      :style="getStyleAvatar(item.avatar)"
                                    ></div>
                                    <img v-else src="@/assets/img/no-foto.png">
                                  </v-list-item-avatar>
                                  <v-list-item-content>
                                    <v-list-item-title 
                                      class="action-link"
                                      v-text="item.name + ' ' + item.lastName"
                                      @click="goToProfile(item.id)"
                                    ></v-list-item-title>
                                  </v-list-item-content>

                                </v-list-item>
                              </v-list>
                            </template>
                          </user-card>
                        </v-expansion-panel-content>
                      </v-expansion-panel>

                      <v-expansion-panel v-if="data.subordinates.length > 0">
                        <v-expansion-panel-header>Подчиненные</v-expansion-panel-header>
                        <v-expansion-panel-content>
                          <user-card class="user-card">
                            <template v-slot:body>
                              <v-list>
                                <v-list-item v-for="item in data.subordinates" :key="item.id">
                                  
                                  <v-list-item-avatar>
                                    <div 
                                      v-if="item.avatar"
                                      class="custom-bg-img"
                                      :style="getStyleAvatar(item.avatar)"
                                    ></div>
                                    <img v-else src="@/assets/img/no-foto.png">
                                  </v-list-item-avatar>
                                  <v-list-item-content>
                                    <v-list-item-title 
                                      class="action-link"
                                      v-text="item.name + ' ' + item.lastName"
                                      @click="goToProfile(item.id)"
                                    ></v-list-item-title>
                                  </v-list-item-content>

                                </v-list-item>
                              </v-list>
                            </template>
                          </user-card>
                        </v-expansion-panel-content>
                      </v-expansion-panel>
                      <!-- {{ data.files }} -->
                      <v-expansion-panel v-if="data.files && data.files.length">
                        <v-expansion-panel-header>Загруженные файлы</v-expansion-panel-header>
                        <v-expansion-panel-content>
                          <!-- <section class="container-tab rel">
                            <table>
                              <tr>
                                <td v-for="file in data.files" :key="file.id" class="custom-i">
                                  <a :href="rootUrl + file.fileLink" target="_blank" :title="file.fileName">
                                    <i :class="fileIcon(file.fileExtension)"></i>
                                    <span>{{ file.fileName }}</span>
                                  </a>
                                </td>
                              </tr>
                            </table>
                          </section> -->

                          <EditFiles
                            class="files-block"
                            :dataFiles="data.files"
                            :isAdmin="isAdmin"
                            :id="data.id"
                            page="user"
                            @saveFile="saveFile"
                          >
                          </EditFiles>
                        </v-expansion-panel-content>
                      </v-expansion-panel>

                      <v-expansion-panel v-if="showInterviewPanel">
                        <v-expansion-panel-header>Интервью</v-expansion-panel-header>
                        <v-expansion-panel-content>
                          <user-card class="user-card">
                            <template v-slot:body>
                              <v-list v-for="(list, type) in interviews" :key="type">
                                
                                <div v-if="list.length > 0" class="user-card_interview_subtitle">{{ interviewType(type) }}</div>

                                <v-list-item  v-for="interview in list" :key="type + '-' + interview.id">
                                  <v-list-item-content>

                                    <div class="user-card_flex-block">
                                      <div class="user-card_interview_date">{{ formatDate(interview.dateTime) }}</div>
                                      <span class="user-card_interview_status">{{ getStatusInterview(interview.status) }}</span>
                                    </div>
                                    <v-list-item-title 
                                      v-text="interview.title" 
                                      class="user-card_interview_title" 
                                      @click.prevent="openInterviewPage(interview.id)"
                                    ></v-list-item-title>

                                  </v-list-item-content>
                                </v-list-item>

                              </v-list>
                            </template>
                          </user-card>
                        </v-expansion-panel-content>
                      </v-expansion-panel>

                    </v-expansion-panels>
                  </v-col>
                </v-row>
              </template>
            </user-card>
          </div>
          <div class="col-12 col-md-7">
            
            <!-- Компетенции по области знаний -->
            <transition name="fade">
              <div class="row" v-if="(softSkills.areas.length > 0 || hardSkills.areas.length > 0) && !editProfile">
                <section class="custom-user-static block-flex-max">
                  <div v-if="showSoftSkills" class="col-12 col-md-6 user-custom-skills">
                    <div class="user-cards-competentions user-cards-competentions-page">
                      <div class="group-skills">
                        <div class="container-title">
                          <h3 class="un-hover" v-if="softSkills.areas.length > 0" @click="goToCompetentions(softSkills.tag)">{{softSkills.title}}</h3>
                          <h3 v-else>{{softSkills.title}}</h3>
                          <v-btn v-if="isAdmin" class="edit-skill-button"
                            title="Назначить SS"
                            variant="text"
                            text
                            @click="goToAppointment('SS')"
                          >
                            <v-icon>mdi-pencil-outline</v-icon>
                          </v-btn>
                        </div>
                        <v-expansion-panels v-for="(area) in softSkills.areas" :key="area.id" multiple>
                          <v-expansion-panel>

                            <v-expansion-panel-header v-show="canShowSkill(area)" class="title-skill">
                              <div class="static-container">
                                <div v-if="area.viewerRights && area.viewerRights.canViewScore" class="ss-mark">
                                  <span v-if="area.score" class="white--text mark-LK">{{getNumber(area.score)}}</span>
                                  <span v-else class="white--text mark-LK">0</span>
                                </div>
                                <span v-else class="white--text"></span>
                                <div class="interview-title max-80">
                                  <h3 style="word-wrap: break-word;">{{area.title}}</h3>
                                  <p v-show="area.description">{{area.description}}</p>
                                </div>
                                
                              </div>
                            </v-expansion-panel-header>

                            <v-expansion-panel-content>
                              <div v-for="item in area.children" :key="item.id">
                                <div v-show="canShowSkill(item)" class="title-skill title-border">
                                  <div class="static-container">
                                    <div v-if="item.viewerRights && item.viewerRights.canViewScore" class="hs-mark hs-mark-light">
                                      <span v-if="item.score" class="mark-LK">{{getNumber(item.score)}}</span>
                                      <span v-else class="mark-LK">0</span>
                                    </div>
                                    <span v-else class="white--text"></span>
                                    <div class="interview-title max-80">
                                      <h3 style="word-wrap: break-word;">{{item.title}}</h3>
                                      <p v-show="item.description">{{item.description}}</p>
                                    </div>
                                    
                                  </div>
                                </div>
                              </div>
                            </v-expansion-panel-content>

                          </v-expansion-panel>
                        </v-expansion-panels>
                      </div>
                    </div>
                  </div>
                  <!-- {{ hardSkills.areas }} -->
                  <div v-if="showHardSkills" class="col-12 col-md-6 user-custom-skills">
                    <div class="user-cards-competentions user-cards-competentions-page hard">
                      <div class="group-skills">
                        <div class="container-title">
                          <h3 class="un-hover" v-if="hardSkills.areas.length > 0" @click="goToCompetentions(hardSkills.tag)">{{hardSkills.title}}</h3>
                          <h3 v-else>{{hardSkills.title}}</h3>
                          <v-btn v-if="isAdmin" class="edit-skill-button"
                            title="Назначить HS"
                            variant="text"
                            text
                            @click="goToAppointment('HS')"
                          >
                            <v-icon>mdi-pencil-outline</v-icon>
                          </v-btn>
                        </div> 
                        <v-expansion-panels v-for="(area) in hardSkills.areas" :key="area.id" multiple>
                          <v-expansion-panel>

                            <v-expansion-panel-header v-show="canShowSkill(area)" class="title-skill">
                              <div class="static-container">
                                <div v-if="area.viewerRights && area.viewerRights.canViewScore" class="hs-mark">
                                  <span v-if="area.score " class="white--text mark-LK">{{getNumber(area.score)}}</span>
                                  <span v-else class="white--text mark-LK">0</span>
                                </div>
                                <span v-else class="white--text"></span>
                                <div class="interview-title max-80">
                                  <h3 style="word-wrap: break-word;">{{area.title}}</h3>
                                  <p>{{area.description}}</p>
                                </div>
                                
                              </div>
                            </v-expansion-panel-header>

                            <v-expansion-panel-content>
                              <div v-for="item in area.children" :key="item.id">
                                <div v-show="canShowSkill(item)" class="title-skill title-border">
                                  <div class="static-container">
                                    <div v-if="item.viewerRights && item.viewerRights.canViewScore" class="hs-mark hs-mark-light">
                                      <span v-if="item.score" class="mark-LK">{{getNumber(item.score)}}</span>
                                      <span v-else class="mark-LK">0</span>
                                    </div>
                                    <span v-else class="white--text"></span>
                                    <div class="interview-title max-80">
                                      <h3 style="word-wrap: break-word;">{{item.title}}</h3>
                                      <p>{{item.description}}</p>
                                    </div>
                                    
                                  </div>
                                </div>
                              </div>
                            </v-expansion-panel-content>

                          </v-expansion-panel>
                        </v-expansion-panels>
                      </div>
                    </div>
                  </div>      
                </section>
              </div>
            </transition>

            <transition name="fade">
              <div class="row" v-if="isAdmin && editProfile">
                <section style="position: absolute">
                  <div class="col-12 editProfile custom-edit-form">
                      <edit-profile-form 
                        :data="cloneData" 
                        @updateDataUser="updateDataUser" 
                        @closeWindow="closeWindow"
                      > 
                      </edit-profile-form>
                  </div>
                </section>
              </div>
            </transition>

          </div>
        </v-row>
        
      </v-container>
    </transition>
  </section>
</template>
<script>
import EditProfileForm from "./UserProfile/EditProfileForm.vue";
import AddInterview from "./UserProfile/AddInterview.vue";
import MembersCard from "./UserProfile/MembersCard.vue";

import UserCard from "./UserProfileTeamplate/UserCard.vue";
import UserInfoCard from "@/pages/UserProfileTeamplate/UserInfoCard";
import UserManagersCard from "@/pages/UserProfileTeamplate/UserManagersCard";
import CategoryLayout from "@/layout/categories/CategoryLayout.vue";
import Categories from "@/components/Catergories/Categories.vue";
import EditFiles from "@/components/EditFiles.vue";
import GlobalRequest from "@/plugins/globalRequest"
import globalMethods from "@/plugins/globalMethods"

export default {
  components: {
    AddInterview,
    EditProfileForm,
    MembersCard,
    UserCard,
    UserInfoCard,
    UserManagersCard,
    CategoryLayout,
    Categories,
    GlobalRequest,
    EditFiles,
    globalMethods
  },

  inject: ["openInterview"],

  data() {
    return {
      curUser: 0,
      preloader: true,
      filelist: [],
      File: [],
      editProfile: false,
      data: {
        id: null,
        name: "",
        lastName: "",
        secondName: "",
        email: "",
        telegram: "",
        phone: "",
        mobile: "",
        avatar: null,
        login: "",
        status: "",
        externalSystem: "",
        externalId: "",
        heads: [],
        subordinates: [],
        files: []
      },
      files: [],
      newFiles: [],
      dataCategory: [],
      hardSkills: { areas: [], title: "", tag: "" },
      softSkills: { areas: [], title: "", tag: "" },
      cloneData: {},
      flag: false,
      userBlocks: true,
      fileError: "",
      roles: [],
      rolesName: [],
      currentUserCard: 0,
      isAdmin: false,
      interviews: {},
      rootUrl: process.env.VUE_APP_FILE_URL
    };
  },

  watch: {
    '$route.query.userID': {
      immediate: false,
      handler(newVal, oldVal) {
        // если userID изменился — грузим заново
        if (String(newVal || '') !== String(oldVal || '')) {
          this.curUser = newVal || 0;
          this.getData();
        }
      }
    }
  },

  mounted() {
    this.currentUserCard = localStorage.getItem('current_user')
    if(this.$route.query.userID) this.curUser = this.$route.query.userID

    this.roles = globalMethods.getRoles()
    this.isAdmin = globalMethods.isAdmin(this.roles);

    this.getData()
    this.getUserStatus()

    // названия ролей для карточки
    for(let i in this.roles) {
      this.rolesName.push(this.roles[i])
    }
  },

  computed: {
    showSoftSkills() {
      return this.isAdmin || (this.softSkills && this.softSkills.areas && this.softSkills.areas.length > 0);
    },

    showHardSkills() {
      return this.isAdmin || (this.hardSkills && this.hardSkills.areas && this.hardSkills.areas.length > 0);
    },

    showInterviewPanel() {
      return (
        (Array.isArray(this.interviews.owned) && this.interviews.owned.length > 0) ||
        (Array.isArray(this.interviews.participated) && this.interviews.participated.length > 0) ||
        (Array.isArray(this.interviews.interviewed) && this.interviews.interviewed.length > 0)
      );
    }
  },

  methods: {

    getUserStatus() {
      const map = globalMethods.userStatus();
      return map[this.data.status] || "";
    },

    goToCompetentions(type) {
      this.$router.push({
        name: 'areasLayout',
        query: {
          userID: this.data.id,
          // typeSkill: type,
          back: this.$route.name
        }
      })
    },

    goToCompetency(item, areaPath) {
      let path = item.element.path
      if(areaPath) {
        path = areaPath + "/" + item.element.path
      }
      console.log(path)
      this.$router.push({
        path: "areasLayout/" + path,
        params: {
          [item.element.key]: item.element.path,
          id: item.element.id,
          header: item.element.title,
          back: this.$route.name
        },
        query: {
          userID: this.data.id,
          elementID: item.element.id,
          parent: areaPath,
          back: this.$route.name
        }
      });
    },

    goToAppointment(type) {
      this.$router.push({
        name: 'areasLayout',
        query: {
          userID: this.data.id,
          back: this.$route.name
        }
      })
    },
    
    goBack() {
      this.$router.push({
        name: this.$route.query.back,
        query: this.$route.query
      })
    },

    getUserId() {
      const route = this.$route;
      const query = route && route.query;

      if (query && query.userID) {
        return query.userID;
      }

      const stored = localStorage.getItem("current_user");
      return stored || null;
    },

    normalizeArray(value) {
      return Array.isArray(value) ? value : [];
    },

    normalizeUserData(data) {
      return {
        ...data,
        heads: this.normalizeArray(data && data.heads),
        subordinates: this.normalizeArray(data && data.subordinates),
        files: this.normalizeArray(data && data.files)
      };
    },

    finalizeLoad() {
      this.flag = true;
      this.preloader = false;
    },

    async getData() {
      this.preloader = true;

      const userId = this.getUserId();
      if (!userId) {
        console.warn("ID пользователя нет");
        this.finalizeLoad();
        return;
      }

      try {
        const res = await GlobalRequest.request(`/user/${userId}`, "GET");
        this.data = this.normalizeUserData((res && res.data) || {});
      } catch (e) {
        console.error("Данные пользователя не получены:", e);
        this.data = this.normalizeUserData({});
      }

      try {
        const result = await GlobalRequest.request(`/root/${userId}`, "GET");

        const dataResult = result ? result : {};

        const hs = dataResult && dataResult.hardSkills ? dataResult.hardSkills : {};
        const ss = dataResult && dataResult.softSkills ? dataResult.softSkills : {};

        this.hardSkills = {
          title: hs.title || "",
          tag: hs.tag || "",
          areas: this.normalizeArray(hs.areas)
        };

        this.softSkills = {
          title: ss.title || "",
          tag: ss.tag || "",
          areas: this.normalizeArray(ss.areas)
        };

        console.log(this.hardSkills)

      } catch (e) {
        console.error("Ошибка загрузки компетенций:", e);
        this.hardSkills = [];
        this.softSkills = [];
      }

      // Интервью
      const result = await GlobalRequest.request( "/interviews/user/" + userId, "GET");
      this.interviews = result && result.data ? result.data : {};

      this.finalizeLoad();
    },

    getClasses(index) {
      var remainder = index % 3;
      if (remainder === 0) {
        return "col-lg-3 offset-lg-1";
      } else if (remainder === 2) {
        return "col-lg-4";
      } else {
        return "col-lg-3";
      }
    },

    openCardEditor() {
      this.editProfile = true;
      let obj = JSON.stringify(this.data);
      this.cloneData = JSON.parse(obj);
    },

    // Назначение интервью
    addInterview() {
      this.openInterview(this.curUser);
    },

    async updateDataUser(newData) {
      let phone = (newData.phone || "").replace(/[-() ]/g, "");
      let mobile = (newData.mobile || "").replace(/[-() ]/g, "");

      let body = {
        login: newData.login,
        email: newData.email,
        name: newData.name,
        secondName: newData.secondName,
        lastName: newData.lastName,
        phone: phone,
        mobile: mobile,
        telegram: newData.telegram
      };
      
      await GlobalRequest.request("/user/" + this.data.id + "/update", "POST", body);

      let res = await GlobalRequest.request("/user/" + newData.id, "GET")
      this.data = res.data
      this.editProfile = false;
    },

    closeWindow: function () {
      this.editProfile = false;
      this.showInterview = false;
    },

    async saveFile(formData) {
      await GlobalRequest.request("/user/" + this.data.id + "/file/upload", "POST", formData, "multipart/form-data");
    },

    getNumber(num) {
      return globalMethods.getNumber(num)
    },

    getStyleAvatar(path) {
      return 'background-image: url("' + path + '"); height: 100%; width: 100%; '
    },

    getStatusColor(status) {
      const map = globalMethods.userStatusClass();
      return map[status] || "";
    },

    interviewType(type) {
      const map = globalMethods.interviewUserType();
      return map[type] || "";
    },

    getStatusInterview(status) {
      const map = globalMethods.interviewStatusLabels();
      return map[status] || "";
    },

    formatDate(value) {
      if (!value) return "";

      const [date, time] = value.split('T');
      const [year, month, day] = date.split('-');

      return `${day}.${month}.${year} ${time}`;
    },

    // canShowSkill(area) {
    //   const storedUserId = localStorage.getItem("current_user");

    //   return Boolean(
    //     ((!this.curUser || this.curUser == storedUserId) && 
    //       area &&
    //       area.viewerRights &&
    //       area.viewerRights.canView) ||
    //     (this.curUser && this.curUser != storedUserId &&
    //       area &&
    //       area.targetRights &&
    //       area.targetRights.assigned &&
    //       area.viewerRights &&
    //       area.viewerRights.canView)
    //   );
    // },

    canShowSkill(area) {
      if (!area) return false;

      const storedUserId = localStorage.getItem("current_user");
      const isSelf = !this.curUser || String(this.curUser) === String(storedUserId);
      const canView = !!(area.viewerRights && area.viewerRights.canView);
      const isAssignedToTarget = !!(area.targetRights && area.targetRights.assigned);

      // свои скиллы
      if (isSelf) return canView;

      // скиллы другого пользователя
      return isAssignedToTarget && canView;
    },

    openInterviewPage(id) {
      this.$router.push({
        name: "InterviewDetail",
        query: {
          back: this.$route.name,
          id: id
        }
      });
    },

    goToProfile(id) {
      this.$router.push({
        name: 'profile',
        query: {
          userID: id,
          back: this.$route.name
        }
      });
    },

    fileIcon(ext) {
      const map = {
        doc: "fa fa-file-word-o",
        docx: "fa fa-file-word-o",
        xls: "fa fa-file-excel-o",
        xlsx: "fa fa-file-excel-o",
        jpg: "fa fa-file-image-o",
        jpeg: "fa fa-file-image-o",
        png: "fa fa-file-image-o",
        pdf: "fa fa-file-pdf-o",
      };
      return map[ext] || "fa fa-file-o";
    },

  },
};
</script>

<style>
  .user-custom-skills {
    padding: 0 5px !important;
    z-index: 1;
  }
  .user-cards-competentions .v-expansion-panel-header{
    padding: 12px !important;
  }
  .user-cards-competentions .v-list-item__title{
    font-size: 14px !important;
  }
  .user-cards-competentions-page .v-expansion-panel-content__wrap,
  .user-cards-competentions-page .v-expansion-panel-header{
    padding: 0 !important;
  }
  .user-cards-competentions .v-list-item{
    height: 45px !important;
  }
  .user-cards-competentions .v-avatar{
    background: #1976d2;
    color: #fff;
    font-family: 'Montserrat', sans-serif;
    font-size: 16px;
    height: 28px !important;
    min-width: 28px !important;
    width: 28px !important;
  }
  .hard .v-avatar{
    background: #41b883 !important;
  }
  .user-cards-competentions .user-card .v-list-item:hover{
    background: #fafafa;
  }
  .user-cards-competentions .v-list{
    padding: 0 !important;
  }
  .user-cards-competentions {
    padding: 0 !important;
    margin-top: 13px !important;
  }
  .user-cards-competentions h3 {
    font-family: 'Montserrat', sans-serif;
    text-transform: uppercase;
    font-size: 14px !important;
    font-weight: 600;
    margin: 0;
    padding: 15px 12px;
  }
  .group-skills {
    background: #fafbfb;
    border-radius: 5px;
  }
  .title-skill {
    font-family: 'Montserrat', sans-serif;
  }
  .user-cards-competentions-page .title-border {
    border-top: 4px solid #fff;
  }
  .custom-cursor {
    cursor: pointer;
  }
  .v-application .custom-title {
    font-family: 'Montserrat', sans-serif !important;
  }
  .user-cards-competentions-page .interview-title p {
    /* height: 40px; */
    overflow: hidden;
    line-height: 1.2;
    font-size: 13px;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    overflow: hidden;
  }
  .height-h3 {
    height: 20px;
    overflow: hidden;
  }
  .user-cards-competentions-page {
    margin-top: 0 !important;
  }
  .link-title {
    transition: 0.3s;
    cursor: pointer;
  }
  .link-title:hover {
    text-decoration: underline;
  }
  .custom-user-static .static-container {
    width: 85%;
    align-items: center;
  }
  .custom-user-static .title-skill {
    width: 100%;
  }
  .block-flex-max {
    /* position: absolute;  */
    display: flex;
  }
  @media (max-width: 768px){
    .block-flex-max {
      display: block;
      position: relative;
    }
    .block-flex-max .user-custom-skills:last-child{
      margin-top: 20px;
    }
  }
  .white--text {
    min-width: 12px;
  }

</style>
